import type { LookupSiteResponsePayload } from '../agent/messages'

let siteInfo: LookupSiteResponsePayload | null = null
const listeners = new Set<() => void>()

export const siteInfoStore = {
  get: () => siteInfo,

  set: (next: LookupSiteResponsePayload | null) => {
    siteInfo = next
    listeners.forEach(it => it())
  },

  subscribe: (listener: () => void) => {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  },
}
